/* 21/10 : quiz joué dans la carte de fin de grille des collections (snippets/mf-grid-fill.liquid).
   Les questions 2 et 3 s'affichent dans la carte ; les résultats aussi quand la carte est large,
   sinon dans une fenêtre du bas, fermable par le bouton Fermer, le fond, Échap, un glissement vers le bas
   ou le bouton Retour du téléphone (qui ne quitte donc pas la page). Aucune redirection. */
if (!customElements.get('mf-fill-quiz')) {
  class MfFillQuiz extends HTMLElement {
    connectedCallback() {
      this.steps = [...this.querySelectorAll('.mf-fill__q')];
      this.sheet = this.querySelector('.mf-qsheet');
      this.empty = this.querySelector('.mf-fill__empty');
      this.trail = [];
      this.answers = [];
      this.addEventListener('click', (e) => this.onClick(e));
      this.sheet.addEventListener('click', (e) => {
        if (e.target === this.sheet) this.closeSheet();
      });
      this.sheet.addEventListener('cancel', (e) => {
        e.preventDefault();
        this.closeSheet();
      });
      this.sheet.addEventListener('close', () => document.documentElement.classList.remove('mf-qsheet-open'));
      window.addEventListener('popstate', () => {
        if (this.sheet.open) {
          this.pushed = false;
          this.closeSheet();
        }
      });
      this.initDrag();
    }

    onClick(e) {
      const ans = e.target.closest('.mf-fill__answer');
      if (ans && this.contains(ans)) {
        e.preventDefault();
        this.loadPool();
        this.answer(ans);
        return;
      }
      if (e.target.closest('[data-back]')) this.back();
      else if (e.target.closest('[data-restart]')) this.restart();
      else if (e.target.closest('[data-open]')) this.openSheet();
      else if (e.target.closest('[data-close]')) this.closeSheet();
    }

    // réserve des produits, chargée une seule fois dès la première réponse (pendant les questions 2 et 3)
    loadPool() {
      if (!this.pool) {
        this.pool = fetch(this.dataset.pool)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return [...doc.querySelectorAll('.mf-quiz__product')];
          })
          .catch(() => []);
      }
      return this.pool;
    }

    show(step) {
      this.current = step;
      this.steps.forEach((s) => (s.hidden = s !== step));
      const t = step.querySelector('.mf-fill__title');
      if (t) t.focus({ preventScroll: true });
    }

    answer(btn) {
      const step = btn.closest('.mf-fill__q');
      const n = Number(step.dataset.step);
      this.answers = this.answers.slice(0, n - 1).concat(btn.dataset.tag);
      this.trail = this.trail.filter((s) => Number(s.dataset.step) < n).concat(step);
      const first = this.answers[0];
      const next = this.steps.find((s) => Number(s.dataset.step) === n + 1 && s.dataset.if === first);
      if (next) this.show(next);
      else this.finish();
    }

    back() {
      const prev = this.trail.pop();
      if (prev) {
        this.answers = this.answers.slice(0, Number(prev.dataset.step) - 1);
        this.show(prev);
      }
    }

    restart() {
      if (this.sheet.open) this.closeSheet();
      this.trail = [];
      this.answers = [];
      this.show(this.steps[0]);
    }

    async finish() {
      const pool = await this.loadPool();
      const chosen = this.answers.map((a) => 'quiz-' + a);
      const best = pool
        .map((li, order) => {
          const tags = (li.dataset.tags || '').split(' ');
          return { li, order, score: chosen.filter((c) => tags.includes(c)).length };
        })
        .filter((p) => p.score > 0)
        .sort((a, b) => b.score - a.score || a.order - b.order)
        .slice(0, 3)
        .map((p) => p.li);

      const fill = (list) => {
        list.replaceChildren(...best.map((li) => document.importNode(li, true)));
        if (!best.length) list.replaceChildren(this.emptyItem());
        list.querySelectorAll('img').forEach((img) => (img.loading = 'eager'));
      };
      // carte large (ordinateur, 2 ou 3 cases) : résultats dans la carte ; sinon fenêtre du bas
      if (this.getBoundingClientRect().width >= 640) {
        fill(this.querySelector('.mf-fill__q--result [data-list]'));
        this.show(this.querySelector('.mf-fill__q--result'));
      } else {
        fill(this.sheet.querySelector('[data-list]'));
        this.show(this.querySelector('.mf-fill__q--ready'));
        this.openSheet();
      }
    }

    emptyItem() {
      const li = document.createElement('li');
      li.className = 'mf-fill__none';
      li.textContent = this.empty.textContent;
      return li;
    }

    openSheet() {
      if (this.sheet.open) return;
      this.sheet.showModal();
      document.documentElement.classList.add('mf-qsheet-open');
      this.sheet.querySelector('.mf-qsheet__close').focus({ preventScroll: true });
      // le bouton Retour du téléphone ferme la fenêtre au lieu de quitter la page
      history.pushState({ mfQsheet: true }, '');
      this.pushed = true;
    }

    closeSheet() {
      if (!this.sheet.open || this.closing) return;
      this.closing = true;
      this.sheet.classList.add('is-closing');
      window.setTimeout(() => {
        this.sheet.classList.remove('is-closing');
        this.sheet.querySelector('.mf-qsheet__panel').style.transform = '';
        this.sheet.close();
        this.closing = false;
      }, 220);
      if (this.pushed) {
        this.pushed = false;
        history.back();
      }
    }

    // glisser la fenêtre vers le bas pour la fermer (téléphone)
    initDrag() {
      const panel = this.sheet.querySelector('.mf-qsheet__panel');
      const handle = this.sheet.querySelector('[data-drag]');
      let y0 = null;
      let dy = 0;
      handle.addEventListener('touchstart', (e) => {
        y0 = e.touches[0].clientY;
        dy = 0;
        panel.style.transition = 'none';
      }, { passive: true });
      handle.addEventListener('touchmove', (e) => {
        if (y0 === null) return;
        dy = Math.max(0, e.touches[0].clientY - y0);
        panel.style.transform = `translateY(${dy}px)`;
      }, { passive: true });
      handle.addEventListener('touchend', () => {
        panel.style.transition = '';
        if (dy > 80) this.closeSheet();
        else panel.style.transform = '';
        y0 = null;
      });
    }
  }
  customElements.define('mf-fill-quiz', MfFillQuiz);
}
